export const FETCH_AllRESTTIMINGS_REQUEST = 'FETCH_AllRESTTIMINGS_REQUEST'
export const FETCH_AllRESTTIMINGS_SUCCESS = 'FETCH_AllRESTTIMINGS_SUCCESS'
export const FETCH_AllRESTTIMINGS_FALIURE = 'FETCH_AllRESTTIMINGS_FALIURE'
